<template>
  <div>
    <v-switch v-model="isCreation"
              :label="switchLabel(isCreation)"
              color="valid"
    />
    <template v-if="!isCreation">
      <v-radio-group v-model="control.value"
                     @change="onEditControl('value', $event)"
      >
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('components.searchPlaceholder')"
          single-line
          hide-details
          color="valid"
        />
        <question-edit-panel-table :loading-question-terminate="loadingQuestionMCQ"
                                   :questions-props="availableMCQs"
                                   :search="search"
        />
      </v-radio-group>
    </template>
    <template v-else>
      <form-m-c-q :is-clone="false"
                   :is-modification="false"
                   :just-save="true"
                   @save="save"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormMCQ from '@/components/questions/formMCQ'
import panelMixin from '@/components/questionnaires/fields/editPanels/panelMixin'
import questionPanelMixin from '@/components/questionnaires/fields/editPanels/questionPanelMixin'
import QuestionEditPanelTable
  from '@/components/questionnaires/fields/editPanels/QuestionEditPanelTable/QuestionEditPanelTable'

export default {
  name: 'MCQQuestionEditPanel',
  mixins: [panelMixin, questionPanelMixin],
  components: {
    FormMCQ,
    QuestionEditPanelTable
  },
  data () {
    return {
      loadingQuestionMCQ: true,
      search: ''
    }
  },
  computed: {
    ...mapGetters('Questions', [
      'questionMCQ',
      'questionsMCQ'
    ]),
    ...mapGetters('Questionnaires', [
      'usedQuestionIds'
    ]),
    availableMCQs () {
      return this.questionsMCQ.filter(
        question => question.id === this.control.value || !this.usedQuestionIds.includes(question.id)
      )
    }
  },
  async created () {
    this.loadingQuestionMCQ = false
  },
  methods: {
    ...mapActions('Questions', [
      'createQuestion'
    ]),
    switchLabel (isCreation) {
      return isCreation
        ? this.$t('components.questionnaires.panels.creation')
        : this.$t('components.questionnaires.panels.selection')
    },
    async save (payload) {
      await this.createQuestion(
        {
          question: payload.question,
          saveType: 'saveQuestionnaire'
        }
      )
      this.control.value = this.questionMCQ.id
      this.isCreation = false
    }
  }
}
</script>
